// extracted by mini-css-extract-plugin
module.exports = {"base":"InlineLabel__base__Q1f2q"};